import React from 'react';
import { withFormsy } from 'formsy-react';

import FieldError from './FieldError'

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    // setValue() will set the value of the component, which in
    // turn will validate it and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    const target = event.target;
    this.props.setValue(target.checked);
  }

  componentWillMount() {
    if (this.props.value) {
      this.props.setValue(this.props.value)
    }
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const opts = { checked: this.props.getValue() ? true : false }
    return (
      <div className={`${this.props.className}`}>
        <div className="custom-control custom-checkbox">
          <input
            onChange={this.changeValue}
            onClick={this.props.onClick}
            type='checkbox'
            placeholder={this.props.placeholder}
            id={this.props.id}
            className="custom-control-input"
            disabled={this.props.disabled}
            {...opts}
          />
          <label className="form-check-label custom-control-label" htmlFor={this.props.id}>{this.props.label}</label>
        </div>
        { errorMessage && <FieldError message={errorMessage} /> }
      </div>
    );
  }
}

export default withFormsy(CheckBox);
